import React, { useEffect, useState } from "react";
import Basic from "./Basic";
import Pricing from "./Pricing";
import Resources from "./Resources";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import toast from "react-hot-toast";
import "../../../../../assets/css/dashborad.css";
import "../../../../../assets/css/custom.css";
import InstructorService from "../../../../../services/instructor.service";

interface IInstrument {
  data: any;
}

interface IAccountNav {
  tab: any;
  setTab: any;
}
const Instrument = ({ data }: IInstrument) => {
  const courseId = data?._id;
  const [course, setCourse] = useState(data);
  const [tab, setTab] = useState("basics");
  const [loading, setLoading] = useState(false);
  const [headerImg, setHeaderImg] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    setCourse(data);
  }, [data]);

  const saveCourse = async () => {
    try {
      setLoading(true);
      await InstructorService.updateCourseDetails(courseId, course).then((res)=>{
        toast.success("Updating course details...");
      })
      .catch((err)=>{
        toast.error("Unable to update course");
      })
      await saveFileData();
      toast.success("Changes have been saved.");
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const saveFileData = async () => {
    try {
      let newHeaderImg = "",
        photoslink = "",
        videoslink = "";

      //Upload Header Image
      if (headerImg.length > 0) {
        const formData = new FormData();
        formData.append("files", headerImg[0]);
        toast.success("Uploading header image .....");
        await InstructorService.uploadHeaderImage(courseId, formData).then((res) => {
          if (res.status == 200) {
            toast.success("Header image uploaded");
          }
        })
          .catch((err) => {
            console.log(err);
            toast.error("Unable to upload header image");
          })
      }

      //Upload Photos
      if (photos.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < photos.length; i++) {
          const file = await imageCompression(photos[i], compressionConfig);
          formData.append(`files`, file);
        }

        toast.success("Uploading photos .....");
        await InstructorService.uploadInstrumentPhotos(courseId, formData).then((res) => {
          if (res.status == 200) {
            toast.success("Photos uploaded");
          }
        })
        .catch((err)=>{
          console.log(err);
          toast.error("Unable to upload photos");
        })
      }


      //Upload Videos
      if (videos.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < videos.length; i++) {
          formData.append(`files`, videos[i]);
        }

        toast.success("Uploading videos .....");
        await InstructorService.uploadInstrumentVideos(courseId, formData).then((res)=>{
          if(res.status==200){
            toast.success("Videos uploaded");
          }
        })
        .catch((err)=>{
          console.log(err);
          toast.error("Unable to upload videos");
        })

      }
      return { newHeaderImg, photoslink, videoslink };
    } catch (err) {
      console.log(err);
    }
  };

  const deleteInstrument = async () => {
    try {
      const response = await Swal.fire({
        title: "Are you sure you want to delete the course",
        text: "This action cannot be undone. ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (response.isConfirmed) {
        // await axios.delete(`/api/admin/course/${courseId}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <div className="header mt-md-5">
        <div className="header-body">
          <div className="row align-items-center">
            <div className="col">
              <h6 className="header-pretitle">Overview</h6>
              {course && <h1 className="header-title">{course.title}</h1>}
            </div>
            <div className="col-auto">
              <div className="btn btn-danger" onClick={deleteInstrument}>
                Delete Instrument
              </div>
            </div>
          </div>
          <AccountNav tab={tab} setTab={setTab} />
        </div>
      </div>
      {course && (
        <div className="row justify-content-center px-4 px-lg-0">
          <div className="col-12">
            {tab === "basics" && (
              <Basic
                loading={loading}
                course={course}
                setCourse={setCourse}
                headerImg={headerImg}
                setHeaderImg={setHeaderImg}
                saveCourse={saveCourse}
                videos={videos}
                photos={photos}
                setVideos={setVideos}
                setPhotos={setPhotos}
              />
            )}
            {tab === "pricing" && (
              <Pricing
                loading={loading}
                course={course}
                setCourse={setCourse}
                saveCourse={saveCourse}
              />
            )}
            {tab === "resources" && (
              <Resources
                loading={loading}
                course={course}
                setCourse={setCourse}
                courseId={courseId}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Instrument;

const AccountNav = ({ tab, setTab }: IAccountNav) => {
  return (
    <div className="row align-items-center mt-2">
      <div className="col">
        <ul className="nav nav-tabs nav-overflow header-tabs">
          <li className="nav-item">
            <div
              className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === "basics" && "active"}`}
              onClick={() => setTab("basics")}
            >
              Basics
            </div>
          </li>
          <li className="nav-item">
            <div
              className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === "pricing" && "active"}`}
              onClick={() => setTab("pricing")}
            >
              Pricing
            </div>
          </li>
          <li className="nav-item">
            <div
              className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === "resources" && "active"}`}
              onClick={() => setTab("resources")}
            >
              Resources
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

const compressionConfig = {
  maxSizeMB: 0.1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
};
